// extracted by mini-css-extract-plugin
export default {"container":"CrmGridAddDateFilterDialog_container__ACfiQ"};